<template>
  <v-container id="master-layanan" fluid tag="section" class="cyber-portal">
    <v-row>
      <v-col cols="12">
        <base-material-card color="#018C74" icon="mdi-face-agent" class="glass-card">
          <template v-slot:heading>
            <div class="display-2 font-weight-black cyber-text">
              PORTAL LAYANAN PUBLIK
            </div>
            <div class="subtitle-1 secondary-text font-weight-bold">
              Digitalisasi Akses & Integrasi Pelayanan Terpadu
            </div>
          </template>

          <v-card-text class="mt-4">
            <v-row class="mb-6 align-center">
              <v-col cols="12" md="6">
                <v-btn class="cyber-add-btn" @click="openDialog()">
                  <v-icon left>mdi-plus-network-outline</v-icon>
                  AKTIVASI LAYANAN BARU
                </v-btn>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="search"
                  append-icon="mdi-shield-search"
                  label="Cari database layanan..."
                  single-line
                  hide-details
                  rounded
                  color="#CFA22D"
                  class="cyber-search-bar"
                />
              </v-col>
            </v-row>

            <v-data-table
              :headers="headers"
              :items="layananList"
              :search="search"
              :loading="loading"
              class="cyber-table"
            >
              <template v-slot:item.is_active="{ item }">
                <v-chip
                  x-small
                  :color="item.is_active == 1 ? '#018C74' : '#CFA22D'"
                  label
                  outlined
                  class="font-weight-bold"
                >
                  {{ item.is_active == 1 ? "ONLINE" : "OFFLINE" }}
                </v-chip>
              </template>

              <template v-slot:item.foto="{ item }">
                <div class="photo-hex-frame">
                  <v-img
                    :src="renderImage(item.foto)"
                    aspect-ratio="1.3"
                    width="70"
                    height="50"
                    cover
                    class="rounded-sm shadow-neon"
                  >
                    <template v-slot:placeholder>
                      <v-row class="fill-height ma-0" align="center" justify="center">
                        <v-icon color="#018C74">mdi-loading mdi-spin</v-icon>
                      </v-row>
                    </template>
                  </v-img>
                </div>
              </template>

              <template v-slot:item.nama_layanan="{ item }">
                <div class="d-flex flex-column">
                  <span class="white--text font-weight-black text-uppercase">{{
                    item.nama_layanan
                  }}</span>
                  <small class="secondary-text font-italic">{{
                    item.deskripsi && item.deskripsi.length > 50
                      ? item.deskripsi.substring(0, 50) + "..."
                      : item.deskripsi
                  }}</small>
                </div>
              </template>

              <template v-slot:item.nama_opd="{ item }">
                <div class="d-flex flex-wrap py-1">
                  <v-chip
                    v-for="nama in daftarNamaOpd(item)"
                    :key="nama"
                    color="#018C74"
                    class="font-weight-bold px-3 mr-1 my-1"
                    label
                    small
                  >
                    {{ nama }}
                  </v-chip>
                </div>
              </template>

              <template v-slot:item.link_layanan="{ item }">
                <v-btn
                  small
                  text
                  color="blue-lighten-3"
                  :href="item.link_layanan"
                  target="_blank"
                  class="text-none"
                >
                  <v-icon small left>mdi-link-variant</v-icon> Buka Akses
                </v-btn>
              </template>

              <template v-slot:item.actions="{ item }">
                <v-btn
                  icon
                  color="#018C74"
                  @click="openDialog(item)"
                  class="glow-hover mr-2"
                >
                  <v-icon small>mdi-pencil-box-outline</v-icon>
                </v-btn>

                <v-btn icon color="#ff5252" @click="deleteItem(item)" class="glow-hover">
                  <v-icon small>mdi-trash-can-outline</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </base-material-card>
      </v-col>
    </v-row>

    <v-dialog v-model="dialog" max-width="800px" persistent overlay-opacity="0.9">
      <v-card class="cyber-dialog-card">
        <v-card-title class="dialog-header-gradient">
          <div class="display-1 white--text font-weight-black">
            <v-icon left color="#CFA22D" size="32">mdi-access-point-network</v-icon>
            {{ formTitle.toUpperCase() }}
          </div>
          <v-spacer />
          <v-btn icon @click="close"><v-icon>mdi-close-circle-outline</v-icon></v-btn>
        </v-card-title>

        <v-card-text class="pt-8 px-8">
          <v-row dense>
            <v-col cols="12" class="mb-4">
              <v-card flat color="rgba(1, 140, 116, 0.1)" class="pa-3 border-glow-green">
                <v-switch
                  v-model="editedItem.is_active"
                  :label="`STATUS PUBLIKASI: ${
                    editedItem.is_active == 1
                      ? 'AKTIF / TERLIHAT'
                      : 'DRAFT / DISEMBUNYIKAN'
                  }`"
                  :true-value="1"
                  :false-value="0"
                  color="#CFA22D"
                  inset
                  hide-details
                ></v-switch>
              </v-card>
            </v-col>

            <v-col cols="12">
              <div class="white--text mb-2 font-weight-bold" style="letter-spacing: 1px">
                <v-icon small color="#CFA22D">mdi-map-marker-radius</v-icon> LOKASI TITIK
                LAYANAN (Drag marker)
              </div>
              <div id="map-container" class="cyber-map-box"></div>
              <v-text-field
                v-model="editedItem.latlong"
                label="Koordinat Geospasial (Format: lat,lng)"
                outlined
                dense
                color="#CFA22D"
                class="mt-2 cyber-field"
                prepend-inner-icon="mdi-crosshairs-gps"
                @input="updateMapFromInput"
                hint="Contoh: -7.9134,113.8214"
                persistent-hint
              />
            </v-col>

            <v-col cols="12">
              <v-autocomplete
                v-model="editedItem.opd_id"
                :items="opdOptions"
                item-text="nama_opd"
                item-value="id"
                label="Otoritas Penanggung Jawab (OPD)"
                outlined
                multiple
                chips
                small-chips
                deletable-chips
                color="#018C74"
                prepend-inner-icon="mdi-shield-account"
                class="cyber-field"
                clearable
                placeholder="Cari instansi atau dinas..."
                hint="Bisa memilih lebih dari satu OPD jika layanan dikelola bersama"
                persistent-hint
                no-data-text="OPD tidak ditemukan dalam database"
              />
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="editedItem.nama_layanan"
                label="Nomenklatur Layanan"
                outlined
                color="#018C74"
                prepend-inner-icon="mdi-label-variant"
                class="cyber-field"
              />
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="editedItem.link_layanan"
                label="Endpoint URL (Akses Link)"
                outlined
                color="#CFA22D"
                placeholder="https://..."
                prepend-inner-icon="mdi-web-check"
                class="cyber-field"
              />
            </v-col>

            <v-col cols="12">
              <v-textarea
                v-model="editedItem.deskripsi"
                label="Abstraksi Layanan"
                outlined
                color="#018C74"
                rows="2"
                prepend-inner-icon="mdi-text-box-search-outline"
                class="cyber-field"
              />
            </v-col>

            <v-col cols="12">
              <v-textarea
                v-model="editedItem.syarat_ketentuan"
                label="Prosedur & Protokol (Syarat/Ketentuan)"
                outlined
                color="#018C74"
                rows="3"
                prepend-inner-icon="mdi-file-eye-outline"
                class="cyber-field"
              />
            </v-col>

            <v-col cols="12" md="7">
              <v-file-input
                v-model="imageFile"
                label="Unggah Representasi Visual"
                accept="image/*"
                outlined
                color="#018C74"
                prepend-icon=""
                prepend-inner-icon="mdi-camera-gopro"
                @change="previewImage"
                class="cyber-field"
              />
            </v-col>

            <v-col cols="12" md="5" class="d-flex align-center justify-center">
              <v-expand-transition>
                <div v-if="imageUrl" class="img-preview-container">
                  <div class="scan-line"></div>
                  <v-img
                    :src="imageUrl"
                    max-height="120"
                    contain
                    class="rounded border-glow-green"
                  />
                </div>
              </v-expand-transition>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions class="pa-8">
          <v-btn text @click="close" class="white--text opacity-6 font-weight-bold"
            >BATAL</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn class="cyber-save-btn" :loading="loading" @click="save">
            SIMPAN DATA
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import axios from "axios";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

const BASE_URL = "https://berkah.bondowosokab.go.id:5500";
const CENTER_BONDOWOSO = [-7.9134, 113.8214];

const LAYANAN_URL = `${BASE_URL}/layanan-new`;

export default {
  data: () => ({
    search: "",
    loading: false,
    dialog: false,
    map: null,
    marker: null,
    layananList: [],
    opdOptions: [],
    imageFile: null,
    imageUrl: null,
    headers: [
      { text: "VISUAL", value: "foto", width: "110px", sortable: false },
      { text: "NAMA LAYANAN", value: "nama_layanan" },
      { text: "OTORITAS", value: "nama_opd" },
      { text: "STATUS", value: "is_active", align: "center", width: "100px" },
      { text: "LINK", value: "link_layanan", sortable: false },
      { text: "AKSI", value: "actions", sortable: false, align: "end" },
    ],
    editedIndex: -1,
    editedItem: {
      id: null,
      opd_id: [],
      nama_layanan: "",
      deskripsi: "",
      syarat_ketentuan: "",
      link_layanan: "",
      foto: "",
      latlong: "-7.9134,113.8214",
      is_active: 1,
    },
    defaultItem: {
      id: null,
      opd_id: [],
      nama_layanan: "",
      deskripsi: "",
      syarat_ketentuan: "",
      link_layanan: "",
      foto: "",
      latlong: "-7.9134,113.8214",
      is_active: 1,
    },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? "Registrasi Layanan Publik"
        : "Konfigurasi Layanan Publik";
    },
  },

  watch: {
    dialog(val) {
      if (val) {
        setTimeout(() => this.initMap(), 300);
      }
    },
  },

  mounted() {
    this.fetchData();
    this.fetchOPD();
  },

  methods: {
    initMap() {
      let currentCoords = CENTER_BONDOWOSO;
      if (this.editedItem.latlong) {
        const splitCoords = this.editedItem.latlong.split(",").map(Number);
        if (splitCoords.length === 2 && !isNaN(splitCoords[0])) {
          currentCoords = splitCoords;
        }
      }

      if (!this.map) {
        this.map = L.map("map-container").setView(currentCoords, 13);
        L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png").addTo(this.map);
        this.marker = L.marker(currentCoords, { draggable: true }).addTo(this.map);

        this.marker.on("dragend", (e) => {
          const { lat, lng } = e.target.getLatLng();
          this.editedItem.latlong = `${lat.toFixed(7)},${lng.toFixed(7)}`;
        });

        this.map.on("click", (e) => {
          const { lat, lng } = e.latlng;
          this.marker.setLatLng([lat, lng]);
          this.editedItem.latlong = `${lat.toFixed(7)},${lng.toFixed(7)}`;
        });
      } else {
        this.marker.setLatLng(currentCoords);
        this.map.setView(currentCoords, 13);
        this.map.invalidateSize();
      }
    },

    updateMapFromInput(val) {
      if (!val || !this.marker) return;
      const coords = val.split(",");
      if (coords.length === 2) {
        const lat = parseFloat(coords[0]);
        const lng = parseFloat(coords[1]);
        if (!isNaN(lat) && !isNaN(lng)) {
          const newPos = [lat, lng];
          this.marker.setLatLng(newPos);
          this.map.panTo(newPos);
        }
      }
    },

    renderImage(filename) {
      if (!filename) return null;
      return encodeURI(`${BASE_URL}/uploads/${filename}`);
    },

    normalizeOpdIds(val) {
      if (Array.isArray(val)) return val.map(Number);
      if (val === null || val === undefined || val === "") return [];
      return [Number(val)];
    },

    daftarNamaOpd(item) {
      const ids = this.normalizeOpdIds(item.opd_id);
      const names = ids
        .map((id) => {
          const opd = this.opdOptions.find((o) => o.id === id);
          return opd ? opd.nama_opd : null;
        })
        .filter(Boolean);
      if (names.length) return names;
      return item.nama_opd ? [item.nama_opd] : [];
    },

    async fetchOPD() {
      try {
        const res = await axios.get(`${BASE_URL}/opd`);
        if (res.data && res.data.response) this.opdOptions = res.data.response.data;
      } catch (e) {
        console.error(e);
      }
    },

    async fetchData() {
      this.loading = true;
      try {
        const res = await axios.get(LAYANAN_URL);
        if (res.data && res.data.response) this.layananList = res.data.response.data;
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },

    previewImage() {
      if (this.imageFile) {
        this.imageUrl = URL.createObjectURL(this.imageFile);
      } else {
        this.imageUrl =
          this.editedIndex > -1 ? this.renderImage(this.editedItem.foto) : null;
      }
    },

    openDialog(item) {
      this.editedIndex = item ? this.layananList.indexOf(item) : -1;
      this.editedItem = item
        ? Object.assign({}, item, { opd_id: this.normalizeOpdIds(item.opd_id) })
        : Object.assign({}, this.defaultItem, { opd_id: [] });
      this.imageUrl = item ? this.renderImage(item.foto) : null;
      this.imageFile = null;
      this.dialog = true;
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.imageFile = null;
        this.imageUrl = null;
        this.editedItem = Object.assign({}, this.defaultItem, { opd_id: [] });
        this.editedIndex = -1;
      });
    },

    async save() {
      const opdIds = this.normalizeOpdIds(this.editedItem.opd_id);
      if (!opdIds.length || !this.editedItem.nama_layanan) {
        return alert("Minimal satu OPD dan Nama Layanan wajib diisi!");
      }
      this.loading = true;
      try {
        const formData = new FormData();
        formData.append("opd_ids", JSON.stringify(opdIds));
        formData.append("nama_layanan", this.editedItem.nama_layanan);
        formData.append("deskripsi", this.editedItem.deskripsi || "");
        formData.append("syarat_ketentuan", this.editedItem.syarat_ketentuan || "");
        formData.append("link_layanan", this.editedItem.link_layanan || "");
        formData.append("latlong", this.editedItem.latlong || "");
        formData.append("is_active", this.editedItem.is_active == 1 ? 1 : 0);

        if (this.imageFile) formData.append("foto", this.imageFile);

        if (this.editedIndex > -1) {
          await axios.put(`${LAYANAN_URL}/${this.editedItem.id}`, formData);
        } else {
          await axios.post(LAYANAN_URL, formData);
        }
        this.fetchData();
        this.close();
        alert("Data Layanan Berhasil Disinkronisasi!");
      } catch (e) {
        alert("Gagal menyimpan data");
      } finally {
        this.loading = false;
      }
    },

    async deleteItem(item) {
      if (confirm(`Hapus layanan ${item.nama_layanan}?`)) {
        try {
          await axios.delete(`${LAYANAN_URL}/${item.id}`);
          this.fetchData();
        } catch (e) {
          alert("Gagal menghapus");
        }
      }
    },
  },
};
</script>

<style scoped>
.cyber-portal {
  background: transparent;
}
.cyber-map-box {
  height: 250px;
  width: 100%;
  border: 1px solid #018c74;
  box-shadow: 0 0 15px rgba(1, 140, 116, 0.3);
  border-radius: 4px;
  z-index: 1;
}
.cyber-text {
  letter-spacing: 4px !important;
  text-shadow: 0 0 15px rgba(1, 140, 116, 0.6);
  color: white !important;
}
.secondary-text {
  color: #cfa22d !important;
}
.glass-card {
  background: rgba(0, 20, 18, 0.85) !important;
  backdrop-filter: blur(15px);
  border: 1px solid rgba(1, 140, 116, 0.4) !important;
}
.cyber-table {
  background: transparent !important;
}
.cyber-table >>> th {
  background: rgba(1, 140, 116, 0.15) !important;
  color: #cfa22d !important;
  font-weight: 900 !important;
  border-bottom: 2px solid #018c74 !important;
}
.cyber-add-btn {
  background: linear-gradient(135deg, #018c74 0%, #004d40 100%) !important;
  color: white !important;
  border: 1px solid #cfa22d !important;
  font-weight: 900;
}
.cyber-save-btn {
  background-color: #cfa22d !important;
  color: #002d25 !important;
  font-weight: 900 !important;
}
.photo-hex-frame {
  padding: 3px;
  border: 1px solid #018c74;
  clip-path: polygon(10% 0%, 100% 0%, 90% 100%, 0% 100%);
  background: rgba(1, 140, 116, 0.2);
  display: inline-block;
}
.shadow-neon {
  box-shadow: 0 0 10px rgba(1, 140, 116, 0.5);
}
.cyber-dialog-card {
  background: rgba(0, 12, 10, 0.98) !important;
  border: 2px solid #018c74 !important;
}
.dialog-header-gradient {
  background: linear-gradient(to right, #018c74, transparent);
  border-bottom: 1px solid rgba(207, 162, 45, 0.4);
}
.border-glow-green {
  border: 1px solid #018c74;
  box-shadow: 0 0 10px rgba(1, 140, 116, 0.4);
}
.img-preview-container {
  position: relative;
  padding: 6px;
  border: 1px dashed #cfa22d;
  background: rgba(255, 255, 255, 0.03);
  overflow: hidden;
}
.scan-line {
  position: absolute;
  width: 100%;
  height: 1px;
  background: #cfa22d;
  box-shadow: 0 0 10px #cfa22d;
  animation: scan 3s infinite linear;
  z-index: 5;
}
@keyframes scan {
  0% {
    top: 0;
  }
  100% {
    top: 100%;
  }
}
.glow-hover:hover {
  filter: drop-shadow(0 0 8px currentColor);
  transform: scale(1.1);
}

.cyber-page,
.cyber-container,
.cyber-portal {
  background: transparent !important;
}

.cyber-title,
.cyber-text,
.cyber-id,
.cyber-desc,
.cyber-item-text {
  color: #1c2b28 !important;
  text-shadow: none !important;
}

.secondary-text {
  color: #018c74 !important;
  text-shadow: none !important;
}

.glass-card,
.cyber-card,
.cyber-dialog,
.cyber-dialog-card,
.cyber-modal,
.cyber-map-container,
.cyber-mapping-container,
.cyber-news-container,
.cyber-moments,
.cyber-carousel,
.cyber-agenda,
.cyber-sosmed-header,
.cyber-map-box,
.cyber-map {
  background: #ffffff !important;
  border: 1px solid #eef1f0 !important;
  backdrop-filter: none !important;
  color: #1c2b28 !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04) !important;
}

.dialog-header,
.dialog-header-gradient {
  background: #f4f7f6 !important;
  color: #1c2b28 !important;
  border-bottom: 1px solid #eef1f0 !important;
}

.dialog-header .white--text,
.dialog-header-gradient .white--text,
.cyber-dialog .white--text,
.cyber-dialog-card .white--text {
  color: #1c2b28 !important;
}

.dialog-neon-line,
.neon-line {
  background: linear-gradient(90deg, #018c74, #cfa22d, #018c74) !important;
}

.transparent-table,
.cyber-table,
.transparent-tabs {
  background: #ffffff !important;
  color: #1c2b28 !important;
}

.transparent-table >>> th,
.cyber-table >>> th {
  background: #f4f7f6 !important;
  color: #018c74 !important;
  font-weight: 800;
  border-bottom: 2px solid #018c74 !important;
}

.transparent-table >>> td,
.cyber-table >>> td {
  color: #1c2b28 !important;
  border-bottom: 1px solid #eef1f0 !important;
}

.transparent-table >>> .v-data-table__empty-wrapper,
.cyber-table >>> .v-data-table__empty-wrapper {
  color: #9aa6a3 !important;
}

.cyber-input,
.cyber-field,
.cyber-search,
.cyber-search-field,
.cyber-search-bar,
.cyber-input-mini,
.cyber-input-dense,
.cyber-input-highlight,
.cyber-input-coord,
.cyber-coord-field,
.cyber-select-dense,
.cyber-file-input,
.cyber-datepicker {
  color: #1c2b28 !important;
}

.cyber-input >>> .v-input__control,
.cyber-field >>> .v-input__control,
.cyber-search >>> .v-input__control,
.cyber-search-field >>> .v-input__control,
.cyber-search-bar >>> .v-input__control,
.cyber-input-mini >>> .v-input__control,
.cyber-input-dense >>> .v-input__control,
.cyber-input-highlight >>> .v-input__control,
.cyber-input-coord >>> .v-input__control,
.cyber-coord-field >>> .v-input__control,
.cyber-select-dense >>> .v-input__control,
.cyber-file-input >>> .v-input__control,
.cyber-datepicker >>> .v-input__control {
  background: #ffffff !important;
  border-radius: 10px;
}

.cyber-input >>> input,
.cyber-field >>> input,
.cyber-search >>> input,
.cyber-search-field >>> input,
.cyber-search-bar >>> input,
.cyber-input-mini >>> input,
.cyber-input-dense >>> input,
.cyber-input-coord >>> input,
.cyber-coord-field >>> input,
.cyber-datepicker >>> input,
.cyber-input >>> .v-label,
.cyber-field >>> .v-label,
.cyber-search >>> .v-label,
.cyber-search-field >>> .v-label,
.cyber-search-bar >>> .v-label,
.cyber-select-dense >>> .v-label,
.cyber-datepicker >>> .v-label {
  color: #1c2b28 !important;
}

.cyber-btn-add,
.cyber-add-btn,
.cyber-add-sosmed-btn {
  background: linear-gradient(135deg, #018c74 0%, #02b395 100%) !important;
  color: #ffffff !important;
  font-weight: 700;
  border: none !important;
  box-shadow: 0 8px 20px rgba(1, 140, 116, 0.25) !important;
}

.cyber-btn-save,
.cyber-save-btn {
  background: #018c74 !important;
  color: #ffffff !important;
  font-weight: 700 !important;
  box-shadow: 0 8px 20px rgba(1, 140, 116, 0.25) !important;
}

.icon-scan-box,
.icon-scan-frame,
.preview-container,
.preview-hex-frame,
.preview-mini-frame,
.preview-scanner {
  background: #f4f7f6 !important;
  border: 1px solid #eef1f0 !important;
}

.preview-tag {
  background: #eaf6f3 !important;
  color: #018c74 !important;
  border: 1px solid rgba(1, 140, 116, 0.3) !important;
}

.scan-overlay {
  display: none !important;
}

.shadow-glow,
.shadow-glow-gold,
.shadow-glow-teal {
  box-shadow: 0 6px 16px rgba(1, 140, 116, 0.15) !important;
}

.action-glow.edit-btn,
.action-glow.delete-btn {
  background: transparent !important;
}

.v-data-table >>> .white--text {
  color: #1c2b28 !important;
}
.plain-description {
  color: #4a5a57 !important;
}
</style>
